<template>
  <li
    :id="`article-${article.id}`"
    :class="bem()"
  >
    <div
      :class="bem('title')"
      @click="toggle"
    >
      <div>
        {{ article.title }}
      </div>

      <ExpandButton :expanded="expanded" />
    </div>

    <div :class="bem('container', { collapsed: !expanded })">
      <GenericStructuredText
        :class="bem('body')"
        :content="article.body"
        copy-size="body"
      />

      <Swiper
        ref="carousel"
        :class="bem('slides')"
        :slides-per-view="1.2"
        :space-between="22.5"
        :breakpoints="{
          800: {
            slidesPerView: 3.3,
            spaceBetween: 30
          }
        }"
      >
        <SwiperSlide
          v-for="(slide, idx) in article.slides"
          :key="idx"
          class="slide"
        >
          <DatoCMSImage
            :class="bem('image')"
            :data="slide.image.responsiveImage"
            alt=""
          />

          <DatoStructuredText
            :class="bem('slide-body')"
            :content="slide.copy"
            copy-size="body-sm"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  </li>
</template>

<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Image as DatoCMSImage } from 'vue-datocms'
import type { OwnersGuideArticle } from '~/gql/ownersGuide.gql'

const bem = useBEM('OwnersGuideArticle')

interface Props {
  article: OwnersGuideArticle
}

defineProps<Props>()

const expanded = ref(false)

const toggle = () => {
  expanded.value = !expanded.value
}
</script>

<style lang="postcss">
.OwnersGuideArticle {
  line-height: 20px;
  margin: 0;
  padding: 0;

  &__title {
    @apply flex items-center justify-between text-sm;

    cursor: pointer;
    padding: 15px 10px 15px 0px;
    font-weight: 200;

    .OwnersGuideArticle:not(:first-child) & {
      border-top: 1px solid rgba(0, 0, 0, 0.05);
    }
  }

  .OwnersGuideArticle__container {
    @apply scrollbar-none
      overflow-x-hidden overflow-y-auto
      box-border
      max-h-[2000px];
    
    transition: max-height 0.25s ease-in-out;

    &--collapsed {
      @apply max-h-0;
    }
  }

  .OwnersGuideArticle__body {
    @apply py-sm;
  }
}
</style>
